/**
 * Email allowlist for the API Keys console.
 *
 * An API key is a bearer credential that can read the entire company across all
 * four realms, and once minted it gets copied into BI tools, laptops and chat
 * messages — it can never be un-leaked, only rotated. So minting is restricted
 * to a named owner, not to "any admin".
 *
 * Keep in sync with the backend's `API_KEY_ADMIN_EMAILS` env (default
 * `aa@crystalgroup.in`). This gate is COSMETIC: the API enforces the same check
 * server-side, so someone who hard-edits the bundle to flip this to `true` still
 * gets a 403 from every /api/api-keys call.
 */
const ALLOW = new Set<string>(['aa@crystalgroup.in']);

export function isApiKeyAdmin(email: string | undefined | null): boolean {
  if (!email) return false;
  return ALLOW.has(String(email).trim().toLowerCase());
}
